import ProcurementTenderType from './ProcurementTenderType';

export const getProcurementTenderListInProgress = (payload) => {
  return { payload, type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST };
};

export const getProcurementTenderListInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_SUCCESS,
  };
};

export const getProcurementTenderListInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_FAIL,
  };
};

export const updateProcurementTenderInfoRequest = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.UPDATE_PROCUREMENT_TENDER_INFO_REQUEST,
  };
};

export const getProcurementTenderListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET,
  };
};

export const setActiveTenderItemsRequest = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.SET_ACTIVE_TENDER_ITEM,
  };
};

export const resetActiveTenderItemsRequest = () => {
  return {
    type: ProcurementTenderType.RESET_ACTIVE_TENDER_ITEM,
  };
};
/** get Tender copy action start */

export const getTenderCopyInProgress = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.CREATE_TENDER_COPY,
  };
};

export const getTenderCopyInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.CREATE_TENDER_COPY_SUCCESS,
  };
};

export const getTenderCopyInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.CREATE_TENDER_COPY_FAIL,
  };
};

export const getTenderCopyRequestReset = () => {
  return {
    type: ProcurementTenderType.CREATE_TENDER_COPY_RESET,
  };
};

/** get Tender copy action end */

export const getUpdateTenderProgress = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.UPDATE_TENDER_PROGRESS,
  };
};

export const addNewBidParameterBtn = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.ADD_NEW_BID_PARAMETER_ACTION,
  };
};

export const addNewLaneBtn = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.ADD_NEW_LANE_BUTTON,
  };
};

export const getProcurementLaneInformationInProgress = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION,
  };
};

export const getProcurementLaneInformationInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_SUCCESS,
  };
};

export const getProcurementLaneInformationInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_FAIL,
  };
};

export const getProcurementLaneInformationRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET,
  };
};

export const getProcurementAddLaneInformationInProgress = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION,
  };
};

export const getProcurementAddLaneInformationInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS,
  };
};

export const getProcurementAddLaneInformationInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL,
  };
};

export const getTenderCarrierListInProgress = (payload) => {
  return { payload, type: ProcurementTenderType.GET_TENDER_CARRIER_LIST };
};

export const getTenderCarrierListInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_SUCCESS,
  };
};

export const getTenderCarrierListInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_FAIL,
  };
};

export const getTenderCarrierListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_TENDER_CARRIER_LIST_REQUEST_RESET,
  };
};

export const getProcurementHistoricalBidListInProgress = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST,
  };
};

export const getProcurementHistoricalBidListInSuccess = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS,
  };
};

export const getProcurementHistoricalBidListInFail = (payload) => {
  return {
    payload,
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL,
  };
};

export const getProcurementHistoricalBidListRequestReset = () => {
  return {
    type: ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET,
  };
};
